module.exports = __webpack_public_path__ + "media/images/icon__prize-176556e6e140ec5eae17867291b745a2.png";